import { Flex } from '@chakra-ui/layout';
import SEO from './SEO';

export default function Layout({ children, pageMeta }) {
  return (
    <Flex
      direction="column"
      alignItems="center"
      // maxW={{ xl: '1200px' }}
      marginTop={20}
      justifyContent="center"
    >
      <SEO
        title={pageMeta.title}
        description={pageMeta.description}
        url={pageMeta.url}
        image={pageMeta.image}
        creator={pageMeta.creator}
        keywords={pageMeta.keywords}
      />
      {children}
    </Flex>
  );
}
